import { render, staticRenderFns } from "./NestedDraggableDepartments.vue?vue&type=template&id=4bcd3665&"
import script from "./NestedDraggableDepartments.vue?vue&type=script&lang=js&"
export * from "./NestedDraggableDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports